import { observer } from "mobx-react";
import React, { useContext } from "react";

import BettingTypeStatisticsButton from "@features/offer/mobile/shared/button/BettingTypeStatisticsButton";
import { useRootAppStore } from "@hooks";
import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";
import { MobilePlatform } from "@state/stores/types";
import { THEME_SETTINGS } from "@theme-settings";
import { analyticsTracker } from "@utils/analytics";
import classnames from "classnames";

export const BettingTypeName = observer(function BettingTypeName(props: {
	bettingType?: any;
	offerKey?: any;
	name?: any;
	isFull?: any;
	isGroup?: any;
	index: number;
	setBettingTypeStats: Parameters<
		typeof BettingTypeStatisticsButton
	>[0]["setToggleState"];
	bettingTypeStats: Parameters<
		typeof BettingTypeStatisticsButton
	>[0]["toggleState"];
}) {
	const { name, isFull = false, isGroup = false } = props;

	const favoritesStore = useContext(FavoritesStoreContext);
	const rootStore = useRootAppStore<MobilePlatform>();

	const isFavorite = favoritesStore.isUserFavoriteBettingType(
		props.bettingType?.id,
		props.offerKey?.specifier || null
	);

	const onButtonClick = (e: React.MouseEvent) => {
		e.preventDefault();

		if (!THEME_SETTINGS.features.isFavoritesEnabled) {
			return;
		}
		if (!rootStore.userAuthStore.isLoggedIn) {
			rootStore.favoritePopupStore.activatePopup();
			return;
		}
		if (isFavorite) {
			favoritesStore.removeUserFavoriteBettingType(
				props.bettingType.id,
				props.offerKey.specifier || null
			);
		} else {
			favoritesStore.addUserFavoriteBettingType(
				props.bettingType.id,
				props.offerKey.specifier || null
			);
			analyticsTracker.trackBettingTypeFavorited(
				props.bettingType.simpleName
			);
		}
	};

	const favIconClasses = classnames(
		"offer--additional__fav",
		{
			"offer--group__fav": isGroup,
		},
		"u-icon u-icon--xsml",
		{
			"u-icon--star--str u-color--sent--warning": isFavorite,
			"u-icon--star--alt u-color--sent--muted":
				!isFavorite /* || !rootStore.userAuthStore.isLoggedIn, */,
			/* 	"is-disabled": !rootStore.userAuthStore.isLoggedIn, */
		}
	);

	return (
		<div
			className={classnames("offer--additional__title", {
				"u-display--f--grow": isFull,
			})}
			onClick={onButtonClick}
		>
			{THEME_SETTINGS.features.isFavoritesEnabled && (
				<i className={favIconClasses} />
			)}
			<>{name}</>
		</div>
	);
});
